import { Button, Text } from '@ksyos/design-system';
import { translateKey } from '../../translate';
import { Modal } from './modals/Modal';

interface IReprocessInfoModalProps {
    onNo: () => Promise<void>;
    onYes: () => Promise<void>;
}

export function ReprocessInfoModal(props: IReprocessInfoModalProps) {
    return (
        <Modal
            actionButtons={[
                <Button onClick={async () => await props.onYes()}>{translateKey('common.continue')}</Button>,
            ]}
            isOpen
            onClose={async () => await props.onNo()}
            size="small"
            title="Opnieuw verwerken"
        >
            <Text>
                Je hoeft niet te wachten op het opnieuw verwerken. Het opnieuw verwerken van de processen en
                bijbehorende activiteiten voor de uitbetalingen en facturatie kan lang duren. Of de verwerking succesvol
                is kan een beheerder zien
            </Text>
        </Modal>
    );
}
